import { useMemo } from "react";
import { useCustomerInfoQuery } from "../../SWR/CustomerInfo/useCustomerInfoQuery";
const useCustomerInfo = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const { data, fetchError, mutationError, isLoading, trigger: handleCustomerUpdate, isMutating, } = useCustomerInfoQuery();
    // flatten data to primitives for stability and memoization
    const usesEmail = ((_b = (_a = data === null || data === void 0 ? void 0 : data.customerInfo) === null || _a === void 0 ? void 0 : _a.CommunicationPreferences) === null || _b === void 0 ? void 0 : _b.includes("Email")) || false;
    const usesSMS = ((_d = (_c = data === null || data === void 0 ? void 0 : data.customerInfo) === null || _c === void 0 ? void 0 : _c.CommunicationPreferences) === null || _d === void 0 ? void 0 : _d.includes("Text Message")) || false;
    const phoneNum = (_f = (_e = data === null || data === void 0 ? void 0 : data.customerInfo) === null || _e === void 0 ? void 0 : _e.PhoneNumber) === null || _f === void 0 ? void 0 : _f.number;
    const countryCode = (_h = (_g = data === null || data === void 0 ? void 0 : data.customerInfo) === null || _g === void 0 ? void 0 : _g.PhoneNumber) === null || _h === void 0 ? void 0 : _h.countryCode;
    const phone = (_k = (_j = data === null || data === void 0 ? void 0 : data.customerInfo) === null || _j === void 0 ? void 0 : _j.Phone) !== null && _k !== void 0 ? _k : "";
    const dayBankDays = (_l = data === null || data === void 0 ? void 0 : data.customerInfo) === null || _l === void 0 ? void 0 : _l.DayBankDays;
    const email = (_m = data === null || data === void 0 ? void 0 : data.customerInfo) === null || _m === void 0 ? void 0 : _m.Email;
    const firstName = (_p = (_o = data === null || data === void 0 ? void 0 : data.customerInfo) === null || _o === void 0 ? void 0 : _o.FirstName) !== null && _p !== void 0 ? _p : "";
    const lastName = (_r = (_q = data === null || data === void 0 ? void 0 : data.customerInfo) === null || _q === void 0 ? void 0 : _q.LastName) !== null && _r !== void 0 ? _r : "";
    const showSMSOption = (data === null || data === void 0 ? void 0 : data.showSMSOption) || false;
    const customer = useMemo(() => {
        const prefs = [];
        if (usesEmail)
            prefs.push("Email");
        if (usesSMS)
            prefs.push("Text Message");
        return {
            communicationPreferences: prefs,
            dayBankDays,
            email,
            firstName,
            lastName,
            phone,
            phoneNumber: {
                countryCode: countryCode,
                number: phoneNum,
            },
        };
    }, [usesEmail, usesSMS, dayBankDays, email, firstName, lastName, phone, countryCode, phoneNum]);
    return {
        isLoading,
        isMutating,
        errors: fetchError || mutationError,
        customer,
        showSMSOption,
        handleCustomerUpdate,
    };
};
export default useCustomerInfo;
